// extracted by mini-css-extract-plugin
module.exports = {"modal":"LoginModal_modal__1SLBD","form":"LoginModal_form__15Mt_","control":"LoginModal_control__30DJ0","actions":"LoginModal_actions__3GP1R"};